import React, { FC } from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
  width?: number;
  height?: number;
}

export const IconBoxArrow: FC<React.PropsWithChildren<Props>> = ({ className, width = 32, height = 32 }) => (
  <svg className={classNames([className])} width={width} height={height} viewBox={`0 0 18 18`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2H14.5858L7.29285 9.29297L8.70706 10.7072L15.9971 3.41717V10H17.9971V1C17.9971 0.447715 17.5494 0 16.9971 0H8V2Z" fill="currentColor" />
    <path
      d="M2 7C2 6.44772 2.44772 6 3 6H6V4H3C1.34315 4 0 5.34315 0 7V15C0 16.6569 1.34315 18 3 18H11C12.6563 18 14 16.6581 14 15.0008V12H12V15.0008C12
       15.5526 11.5528 16 11 16H3C2.44772 16 2 15.5523 2 15V7Z"
      fill="currentColor"
    />
  </svg>
);
